import type { ComponentType, FC } from 'react';

import { getCommonFiltersSlice } from '@iconik-io/shared-lib/src/redux/common_filters/slice';
import type {
  CommonFiltersAppState,
  FacetValues,
  FilterValue,
} from '@iconik-io/shared-lib/src/redux/common_filters/types';

import SearchFacets from '../../components/search_facets/search_facets';
import type { CommonListPrefix } from '../../ducks/common_list/types';
import { useAppDispatch } from '../../store/react_redux_typed';
import Form from '../../ui/forms/form';
import formatSnakeCaseTypeToLabel from '../../utils/format_snake_case_type';

import styles from '../search_filters/search_filters.module.css';

export type CustomFilterComponent = ComponentType<{ value: FilterValue }>;

export type CustomFilter = {
  title: string;
  name: string;
  component: CustomFilterComponent;
};

type Props = {
  commonListPrefix: CommonListPrefix;
  filtersPanelState: CommonFiltersAppState;
  onChange: (debounce?: boolean) => void;
  labels?: Record<string, string>;
};

const AdminFilters: FC<Props> = (props) => {
  const { commonListPrefix, onChange, filtersPanelState, labels } = props;

  const dispatch = useAppDispatch();
  const actions = getCommonFiltersSlice(commonListPrefix).actions;

  return (
    <div className={styles.form}>
      <Form<FacetValues>
        onChange={(facetValues) => {
          dispatch(actions.setFacetValues(facetValues));
          onChange();
        }}
      >
        <SearchFacets
          availableFacets={filtersPanelState.availableFacets}
          facetValues={filtersPanelState.facetValues}
          labels={labels}
          labelFormatter={(_facetKey, bucketKey) =>
            labels?.[bucketKey]
              ? labels[bucketKey]
              : formatSnakeCaseTypeToLabel(bucketKey)
          }
          prefix=""
        />
      </Form>
    </div>
  );
};

export default AdminFilters;
